"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./favicon.ico");
require("client/modules/livereload");
const React = require("react");
const ReactDOM = require("react-dom");
const application_1 = require("client/modules/application");
const ag_grid_enterprise_1 = require("ag-grid-enterprise");
const app_settings_1 = require("shared/app-settings");
const logger_1 = require("shared/logger");
const store_1 = require("client/modules/app-settings/store");
let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
let isFirefox = /Firefox/.test(navigator.userAgent); //Mozilla Firefox: E-002
let isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor); //Safari: E-002
let isEdge = /Edge/.test(navigator.userAgent); //Microsoft Edge: E-002
let isIE = /Trident/.test(navigator.userAgent); //Internet Explorer (IE): E-002
var isOpera = /OPR/.test(navigator.userAgent); //Opera: E-002
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
if (isMobile) {
    if (navigator.userAgent.match('CriOS')) {
        isChrome = true;
        isFirefox = true;
        isSafari = true;
        isEdge = true;
        isIE = true;
        isOpera = true;
    }
}
if (!isChrome && !isFirefox && !isSafari && !isEdge && !isIE && !isOpera) { // E-002
    ReactDOM.render(React.createElement("div", { style: { height: '100%', width: '100%', backgroundColor: 'white' } },
        React.createElement("div", { style: {
                margin: 'auto',
                width: '50%',
                textAlign: 'center',
                marginTop: '100px',
                border: '2px solid darkblue',
                padding: '10px',
                backgroundColor: 'white'
            } },
            React.createElement("div", null, "Browser incompatible, please use Chrome"),
            React.createElement("div", null,
                React.createElement("a", { href: "https://www.google.com/chrome/" }, "Download Chrome Here")))), document.querySelector('#root'));
}
else {
    /** Plug ag-Grid license into the code immediately. */
    (async () => {
        if (!store_1.appSettingsStore.agLicense) {
            await store_1.appSettingsStore.readLicense(app_settings_1.LicenseVendor.agGrid);
            ag_grid_enterprise_1.LicenseManager.setLicenseKey(store_1.appSettingsStore.agLicense);
        }
    })()
        .then(() => console.log("AG_SUCCESS"))
        .catch(() => console.log("AG_FAILED"));
    logger_1.Logger.setNamespacePrefix("dispensify:");
    ReactDOM.render(React.createElement(application_1.Application, null), document.querySelector('#root'));
}



//////////////////
// WEBPACK FOOTER
// ./src/client/index.tsx
// module id = 3151
// module chunks = 0